
import { useTranslation } from 'react-i18next';
import VideoPoster from '../../assets/535fbac30da553a0.jpg';
import Video from '../../assets/535fbac30da553a0.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const QualificationSection1 = () => {
  const { t } = useTranslation();
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: 'black',
      ...(isMobile ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: isMobile ? isEng ? '178px' : '136px' : `${topSectionBottom}px`  // ✅ 하단 여백
          }}
        >
          Qualification &<br />Certificate
        </SubH1>
        <H10
          style={{
            width: isMobile ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? '0px' : `${topSectionBottom}px`,
            ...(isMobile
              ? { left: `${padding}px`, minHeight: isEng ? '168px' : '124px' }
              : { right: `${padding}px` }),
          }}
        >
          {t('국내를 비롯한 미국과 중국에 생산 거점을 운영하며, 글로벌 고객에게 신뢰받는 기술을 제공합니다. 지역을 넘어선 확장성과 민첩한 대응력으로, 세계 산업의 중심에서 움직이고 있습니다.')}
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default QualificationSection1;
